import { styled, withUtility } from '@hub-la/design-system';
import { Avatar, css } from '@mui/material';

let _ = t => t,
  _t,
  _t2;
const UserAvatar = styled(Avatar)(_t || (_t = _`
  ${0}
`), withUtility(({
  palette
}, {
  width,
  height
}) => {
  return css(_t2 || (_t2 = _`
      border: 1px solid ${0};
      width: ${0};
      height: ${0};
    `), palette('surfaceVariant'), width, height);
}));

export { UserAvatar };
